import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgxSelectBoxFilter} from "./ngx-select-box-filter";
import {Filter} from "../../../ngx-types";

@Component({
  selector: 'app-select-box',
  templateUrl: './select-box.component.html',
  styleUrls: ['./select-box.component.scss']
})
export class SelectBoxComponent extends NgxSelectBoxFilter implements OnInit {
  @Input() label: string;
  @Input() filter: Filter;
  @Input() options: any;
  @Input() value: any;
  @Output() valueChange = new EventEmitter<any>();

  ngOnInit(): void {
  }

}
